import { Outlet } from "react-router-dom";

import { Footer } from "./components/footer";
import { Header } from "./components/header";

export const HomeLayout = () => (
  <div className="h-screen overflow-x-hidden overflow-y-auto">
    <Header />
    <Outlet />
    <Footer />
  </div>
);
